// extracted by css-extract-rspack-plugin
export default {"nameSlot":"src-modules-desktop-modules-files-integration-components-GridViewItem-components-NameSlot-NameSlot-module__nameSlot-Ec3dqJ","nameContent":"src-modules-desktop-modules-files-integration-components-GridViewItem-components-NameSlot-NameSlot-module__nameContent-vLnZ94","isHidden":"src-modules-desktop-modules-files-integration-components-GridViewItem-components-NameSlot-NameSlot-module__isHidden-o_ilMk"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"nameSlot\":\"src-modules-desktop-modules-files-integration-components-GridViewItem-components-NameSlot-NameSlot-module__nameSlot-Ec3dqJ\",\"nameContent\":\"src-modules-desktop-modules-files-integration-components-GridViewItem-components-NameSlot-NameSlot-module__nameContent-vLnZ94\",\"isHidden\":\"src-modules-desktop-modules-files-integration-components-GridViewItem-components-NameSlot-NameSlot-module__isHidden-o_ilMk\"}";
        // 1793875579363
        var cssReload = require("../../../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  